module.exports = __webpack_public_path__ + "r-v3/img/file.a1a223d0.svg";